import { render, staticRenderFns } from "./FormSectionHeader.vue?vue&type=template&id=00462af4&scoped=true&"
import script from "./FormSectionHeader.vue?vue&type=script&lang=js&"
export * from "./FormSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormSectionHeader.vue?vue&type=style&index=0&id=00462af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00462af4",
  null
  
)

component.options.__file = "FormSectionHeader.vue"
export default component.exports